import { OAuthService } from 'angular-oauth2-oidc';
import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfigService } from '../app-config.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css']
})
export class CallbackComponent implements OnInit, AfterViewInit   {
  loadingIcon: boolean;
  iCounter: any;
  accesToken: any;
  idToken: any;
  maxCounter = 6;
  initialTimeout = 2000;
  maxCounterTimeout = 1500;

  constructor(
    private router: Router,
    private appConfig: AppConfigService,
    private oauthService: OAuthService,
    private cdRef: ChangeDetectorRef) {
    const config = this.appConfig.getConfig() ? this.appConfig.getConfig().CallbackSettings : null;
    if (config) {
      this.maxCounter = config.MaxCounter;
      this.initialTimeout = config.InitialTimeout;
      this.maxCounterTimeout = config.MaxCounterTimeout;
    }
  }

  ngOnInit() {
    this.loadingIcon = true;
    this.iCounter = 0;
    const url = window.location.href;
    const params = this.getAllUrlParams(url);
    if (params && params.length > 0) {
      setTimeout(() => {
        this.isNotAuthorized();
      }, this.initialTimeout);
    }
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  isNotAuthorized(): any {
    if (this.iCounter === this.maxCounter) {
      this.router.navigate(['/forbidden'], { queryParams: { usererror: true } });
      return;
    }
    this.iCounter++;
    setTimeout(() => {
      this.accesToken = this.oauthService.getAccessToken();
      this.idToken = this.oauthService.getIdToken();
      if (sessionStorage.getItem('access_token') === null) {
        if (this.accesToken !== null && this.accesToken !== undefined) {
          sessionStorage.setItem('access_token', this.accesToken);
          sessionStorage.setItem('id_token', this.idToken);
        } else {
          this.isNotAuthorized();
        }
      } else {
        this.goToLandingPage();
      }
    }, this.maxCounterTimeout);
  }

  goToLandingPage(): void {
    this.loadingIcon = false;
    this.iCounter = 0;
    this.router.navigate(['/landing-page']);
  }

  getAllUrlParams(url: any): any {
    // get query string from url (optional) or window
    const queryString = url.split('?')[1];
    // we'll store the parameters here
    const obj = {};
    // if query string exists
    if (queryString) {
      // split our query string into its component parts
      const arr = queryString.split('&');
      return arr;
    }
    return obj;
  }
}
